<template>
  <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="onCreate">
    <v-card tile>
      <v-card-title class="grey lighten-2">
        Skapa försening
      </v-card-title>

      <v-card-text class="mt-2">
        <DelayActivitySearch />
        <DelayLocationFields />
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer />
        <v-btn rounded @click="closeModal">Avbryt</v-btn>
        <v-btn rounded type="submit" color="primary" :loading="createPending">
          Skapa försening
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
import gql from 'graphql-tag'
import { sync } from 'vuex-pathify'
import { required } from '@/common/validationRules'
import DelayLocationFields from './DelayForm/DelayLocationFields'
import DelayActivitySearch from './DelayForm/DelayActivitySearch'

export default {
  name: 'DelayCreateModal',

  components: {
    DelayLocationFields,
    DelayActivitySearch
  },

  data: () => ({
    required,
    valid: true,
    createPending: false
  }),

  created() {
    this.$store.set(
      'delay/model@event_uuid',
      this.$store.get('event/selectedUUID')
    )
  },

  computed: {
    model: sync('delay/model')
  },

  methods: {
    async onCreate() {
      const isValidForm = await this.$refs.form.validate()
      if (!isValidForm) return
      this.createPending = true

      await this.$apollo.mutate({
        mutation: gql`
          mutation($payload: CreateDelayInput!) {
            createDelay(payload: $payload) {
              delay_uuid
            }
          }
        `,
        variables: {
          payload: {
            ...this.model,
            checked: true
          }
        }
      })

      this.createPending = false
      this.$store.commit('delay/create', {
        ...this.model,
        checked: true
      })
      this.closeModal()
    },

    closeModal() {
      this.$store.commit('delay/resetModel')
      this.$emit('close')
    }
  }
}
</script>
